import { render } from "./ListaSinistrosAcordoParcelasView.vue?vue&type=template&id=f27ade70&scoped=true"
import script from "./ListaSinistrosAcordoParcelasView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosAcordoParcelasView.vue?vue&type=script&lang=js"

import "./ListaSinistrosAcordoParcelasView.vue?vue&type=style&index=0&id=f27ade70&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27ade70"]])

export default __exports__